import {Component} from '@angular/core';

@Component({
    selector: 'tfl-bo-card-box-action',
    template: '<ng-content></ng-content>'
})
export class CardBoxActionComponent {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-box.action.component.ts